<template>
    <div class="rowrapper" :style="{'background-image': 'url(' + require('../../assets/img/zbg.jpg') + ')', 'background-size': 'auto', 'background-position': 'center bottom',  'background-repeat': 'no-repeat'}">
      <div class="div1 colwrapper" >
        <div class="div3" style="height: 25%; padding: 2rem">
          <a href="https://zingerwallet.com" target="__blank">
            <img alt="Zinger" src="../../assets/img/logos/zingerlong.png" height="80" width="140">
          </a>
        </div>
        <div class="div4" style="height: 75%; padding: 2rem;">
          <h3 class="bold-font" style="color: #ffffff;">Welcome to Zinger</h3>
          <h5 class="bold-font" style="color: #ABEBC6;">Log in to proceed</h5>
        </div>
      </div>
      <div class="div2 colwrapper">
        <div class="div3" style="height: 25%;"></div>
        <div class="div4" style="height: 75%;">
          <!-- <div class="page"> -->
            <form class="page" @submit.prevent="login">
              <label class="field field_v1">
                <input class="field__input" placeholder="e.g. johndoe or john@doe.com"
                @input="checkInput()" v-model="username" required>
                <span class="field__label-wrap">
                  <span class="field__label">Username or Email</span>
                </span>
              </label>
              <label class="field field_v2">
                <input class="field__input" :type="inputType" placeholder="Password"
                @input="checkInput()" v-model="password" required>
                <!-- :style="{'background-image': 'url(' + require('../assets/img/icons/show-password.svg') + ')', 'background-position': 'right', 'background-repeat': 'no-repeat'}"> -->
                <span class="field__label-wrap">
                  <span class="field__label">Password</span>
                </span>
                <img src="../../assets/img/icons/show-password.svg" alt="" style="cursor: pointer;" @click="changeInputType">
              </label>
              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" round
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center;" v-if="!isLoading">Log In</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
              </Button> 
              <div style="padding-left: 1rem; padding-right: 1rem;">
                <a href="javascript:void(0)" id="ahov" @click="$modal.show('resetPModal')" v-if="clickR == 0">Forgot Password?</a> 
                <a href="javascript:void(0)" id="ahov2" style="float: right;" @click="goToRegister()">Create Account</a> 
              </div> 
               
              <!-- <label class="field field_v3">
                <input class="field__input" placeholder="e.g. john@doe.com">
                <span class="field__label-wrap">
                  <span class="field__label">E-mail</span>
                </span>
              </label> -->
            </form>
            <!-- <form @submit.prevent="testTopup">
              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" round
              :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center;">Topup</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
              </Button> 
            </form> -->
          <!-- </div> -->
          <div style="padding-right: 1rem; padding-top: 5rem;">
            <a href="https://zingerwallet.com/terms" target="__blank" id="ahov" style="float: right; color: #ABEBC6; font-weight: 300; margin-left: 0.5rem;">Terms</a> 
            <a href="https://zingerwallet.com/privacy" target="__blank" id="ahov2" style="float: right; color: #ABEBC6; font-weight: 300;">Privacy <span style="margin-left: 0.3rem;">|</span></a> 
          </div> 
        </div>
      </div>
      <modal name="resetPModal" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="$modal.hide('resetPModal')" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Reset Password</h3>
            <h4 style="padding-top: .5rem;">Enter your registered email on Zinger to begin</h4> 
            <form class="page2" @submit.prevent="resetP">
              <label class="field field_v1">
                  <input class="field__input" type="email" style="color: black;" placeholder="e.g. john@doe.com" v-model="res_email" required>
                  <span class="field__label-wrap">
                  <span class="field__label">Email</span>
                  </span>
              </label>
              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingR">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingR">
              </Button> 
            </form>
          </div>
        </div>
      </modal>
    </div>
</template>

<script>
import Vue from 'vue';
import router from "../../router";
import Button from "../../components/Button";
import axios from "axios";
import axios1 from '../../AxiosInstance.js';

  export default {
    name: 'login',
    components: {
      Button
    },
    data() {
      return{
        url: process.env.VUE_APP_BASE_URL,
        isLoading: false,
        isDisabled: true,
        username: '',
        password: '',
        buttonType: 'submit', 
        inputType: 'password',
        res_email: null,
        isLoadingR: false,
        clickR: 0,
        profile_id: null,
        rn: null,
      }
    },
    created() {
      document.title = "Zinger - Login";
    },
    mounted() {
      this.checkLoggedIn();
    },
    methods: {
      login(){
        let self = this;
        if(this.username.length < 1 || this.password.length < 1){
          this.isDisabled = true
        }else{
          this.isLoading = true;
          this.isDisabled = false;
          let credentials = {};
          credentials.password = this.password;
          if (this.username.indexOf('@') > -1){
            credentials.email = this.username;
          }else{
            credentials.username = this.username;
          }
          axios.post(this.url + "auth/login/", credentials).then(res => {
            // console.log(res.data)
            localStorage.setItem("token", self.encrypt(res.data.key));
            axios.get(this.url+"api/v1/user-check/", {
              headers: { authorization: "Token " + self.decrypt(localStorage.getItem("token")) }
            }).then(response => {
              // console.log(response.data.results[0])
              this.profile_id = response.data.results[0].profile_id;
              this.username = response.data.results[0].username;
              this.rn = response.data.results[0].rn;

              localStorage.setItem("profile_id", this.encrypt(response.data.results[0].profile_id));
              localStorage.setItem("username", response.data.results[0].username);
              localStorage.setItem("rn", response.data.results[0].user_rn);
              localStorage.setItem("uid", this.encrypt(response.data.results[0].user_data));
              this.getUserProfile().then(function(){
                if(self.decrypt(localStorage.getItem('verified_status')) == 'false'){
                  router.push("/verify");
                }else{
                  // console.log(self.decrypt(localStorage.getItem('reached_limit')))
                  if(self.decrypt(localStorage.getItem('reached_limit')) == 'false' || localStorage.getItem('is_business') == 'true' || localStorage.getItem('is_upgraded') == 'true'){
                    router.push(self.$route.query.redirect || "/");
                  }else{
                    router.push("/upgrade");
                  }
                }
                self.isLoading = false;
              });
            }).catch(e => {
              this.isLoading = false;
              Vue.$toast.open({
                message:
                  "Error Processing! Kindly check yout connection and try again.",
                type: "error",
                position: "top-right",
                duration: 10000,
              });
            });
          }).catch(e => {
            // console.log(e);
            this.isLoading = false;
            if(e.response){
              Vue.$toast.open({
                message:
                  "Invalid Credentials!",
                type: "error",
                position: "top-right",
                duration: 10000,
              });
            }else{
              Vue.$toast.open({
                message:
                  "Error Processing! Kindly check yout connection and try again.",
                type: "error",
                position: "top-right",
                duration: 10000,
              });
            }            
          });
        }
      },
      getUserProfile: async function() {
        let self = this;
        // let rn = parseInt(localStorage.getItem('rn')) + 1;

        // let qrData = {name: 'Zinger', username: this.username, profile_id: this.profile_id, rn: rn};
        // let encData = this.CryptoJS.AES.encrypt(JSON.stringify(qrData), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        // localStorage.setItem('rn', rn);
        return new Promise( async function(resolve, reject) {
          await axios1.get(self.url+"api/v1/user/" + self.decrypt(localStorage.getItem("uid")) + "/", {
            headers: { authorization: "Token " + self.decrypt(localStorage.getItem("token")) }
          }).then(response2 => {
            // console.log(response2.data);
            localStorage.setItem("user_id",self.encrypt(response2.data["id"]));
            localStorage.setItem("username",response2.data["username"]);
            localStorage.setItem("email",response2.data["email"]);
            localStorage.setItem("first_name",response2.data["first_name"]);
            localStorage.setItem("last_name",response2.data["last_name"]);
            localStorage.setItem("has_valid_voucher",response2.data["has_any_valid_voucher"]);
            localStorage.setItem("has_pin",self.encrypt(response2.data["pin_set"].toString()));
            localStorage.setItem("has_signatory",self.encrypt(response2.data["has_signatory"].toString()));
	    localStorage.setItem("has_raffle",self.encrypt(response2.data["has_raffleno"].toString()));
            localStorage.setItem("ref_code",response2.data["profile"]['ref_code']);
            localStorage.setItem("is_signatory",response2.data["is_signatory"]);
            localStorage.setItem("staff_count",response2.data["staff_no_count"]);
            localStorage.setItem("customer_count",response2.data["customer_count"]);
            localStorage.setItem("department_count",response2.data["department_count"]);
            localStorage.setItem("profile_id",self.encrypt(response2.data["profile"]["id"]));
            localStorage.setItem("phone",response2.data["profile"]["phone_number"]);
            localStorage.setItem("rn",response2.data["profile"]["rn"]);
            localStorage.setItem("profile_pic",response2.data["profile"]["profile_pic"]);
            localStorage.setItem("balance",response2.data["profile"]["balance"]);
	    localStorage.setItem("pos_balance",response2.data["profile"]["pos_balance"]);
            localStorage.setItem("is_staff",response2.data["staff_count"]);
            localStorage.setItem("is_business",response2.data["profile"]["is_business"]);
            localStorage.setItem("business_name",response2.data["profile"]["business_name"]);
            localStorage.setItem("is_bvn_verified",response2.data["profile"]["is_bvn_verified"]);
            localStorage.setItem("bvn",response2.data["profile"]["starred_bvn"]);
            localStorage.setItem("dob",response2.data["profile"]["dob"]);
	    localStorage.setItem("tier",response2.data["profile"]["tier_type"]);
            localStorage.setItem("gender",response2.data["profile"]["gender_type"]);
            localStorage.setItem("is_upgraded",response2.data["profile"]["is_upgraded"]);
            localStorage.setItem("can_verify",response2.data["profile"]["canVerify"]);
            localStorage.setItem("ver_can_date",response2.data["profile"]["verCanDate"]);
            localStorage.setItem("total_received_only",response2.data["profile"]["total_received"]["amount__sum"]);
            localStorage.setItem("total_received_bus",response2.data["profile"]["total_received_bus"]["amount__sum"]);
            localStorage.setItem("total_sent",response2.data["profile"]["total_sent"]["amount__sum"]);
            localStorage.setItem("total_withdrawal",response2.data["profile"]["total_withdrawals"]["amount__sum"]);
            localStorage.setItem("verify_id",self.encrypt(response2.data["verify"]["id"]));
            localStorage.setItem("verified_status",self.encrypt(response2.data["verify"]["verified"].toString()));
            localStorage.setItem("reached_limit",self.encrypt("false"));
          }).catch(err1 => {self.isLoading = false;});
          resolve('Profile Get Method finished');
        });
      },
      resetP(){
        this.isLoadingR = true;
        let details = {email: this.res_email}
        axios.post(this.url + "api/password_reset/", details).then(response => {
          this.clickR = 1;
          this.isLoadingR = false;
          this.res_email = null;
          this.$modal.hide('resetPModal');
          this.$toast.info('An email has been sent to you with further instructions', {duration: 5000, position: "top-right"});
        }).catch(err => {
          // console.log(err.response)
          this.clickR = 0;
          this.isLoadingR = false;
          if(err.response){
            if(err.response.data.email){
              this.$toast.error('Email does not exist!', {duration: 5000, position: "top-right"});
            }
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      testTopup(){
        let senderDetails = {
          accountNumber: '9985669400',
          settlementId: '555555555550',
          sessionId: '555555555550',
          sourceAccountName: 'Jude Edijala',
          transactionAmount: 10,
        }
        axios.post(this.url + "api/v1/update-topup-balance/settlement_notif", senderDetails).then(response => {
        //console.log(response);
        }).catch(err => {
          console.log(err);
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      goToRegister(){
        router.push("/register");
      },
      checkInput(){
        if(this.username.length < 1 || this.password.length < 1){
          this.isDisabled = true
        }else{
          this.isDisabled = false;
        }
      },
      changeInputType(){
        if(this.inputType === 'password') {
            this.inputType = 'text'
        } else {
            this.inputType = 'password'
        }
      },
      checkLoggedIn() {
        if (this.decrypt(localStorage.getItem("token"))) {
          router.push("/");
        }
      },
    }
  }
</script>

<style lang="css" scoped>

/* html, body{
  margin: 0;
  overflow: scroll !important;
} */

.rowrapper{
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  align-content: stretch;
  padding: 0 100px; 
  padding-top: 80px;
  background: #28B463;
}

.tvv2{
  /* padding-top: 3rem; */
  text-align: center; 
  height: 100%; 
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  scroll-behavior: smooth;  
}

.page2{
  background: transparent; 
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  display: grid;
  grid-gap: 30px;
}

.div1 {
  width: 100%;
  flex: 1 1 25rem;
}

.div2 {
  width: 100%;
  flex: 1 1 25rem;
}

.div3 {
  width: 100%;
  flex: 1 1 25rem;
}

.div4 {
  width: 100%;
  flex: 1 1 25rem;
}

h1, h2, h3, h4, h5, h6 {
    letter-spacing: -.5px;
    line-height: 1.4;
    margin: 5px 0;
    font-weight: 600;
    font-family: "CW BR Firma",sans-serif;
}

a{
  font-weight: 600;
  font-family: "CW BR Firma",sans-serif;
  color: #2ECC71;
}

#ahov:hover{
  color: #82E0AA;
}

#ahov2:hover{
  color: #82E0AA;
}

.bold-font{
  font-weight: 700;
}

h3 {
  font-size: 3rem;
}

h5 {
  font-size: 1.56rem;
}

@media screen and (max-width: 1024px){
  h3 {
    font-size: 1.98rem;
  }
  h5 {
    font-size: 1.4rem;
  }
}

@media screen and (max-width: 600px){
  .rowrapper {
      padding: 20px 20px 80px;
  }
}

.field__input{ 
  --uiFieldPlaceholderColor: var(--fieldPlaceholderColor, #767676);
  color: #ffffff;
  
  background-color: transparent;
  border-radius: 0;
  border: none;

  -webkit-appearance: none;
  -moz-appearance: none;

  font-family: inherit;
  font-size: inherit;
}

.field__input:focus::-webkit-input-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

.field__input:focus::-moz-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

/*
=====
CORE STYLES
=====
*/

.field{
  --uiFieldBorderWidth: var(--fieldBorderWidth, 2px);
  --uiFieldPaddingRight: var(--fieldPaddingRight, 1rem);
  --uiFieldPaddingLeft: var(--fieldPaddingLeft, 1rem);   
  --uiFieldBorderColorActive: var(--fieldBorderColorActive, rgba(22, 22, 22, 1));

  display: var(--fieldDisplay, inline-flex);
  position: relative;
  font-size: var(--fieldFontSize, 1rem);
}

.field__input{
  box-sizing: border-box;
  width: var(--fieldWidth, 100%);
  height: var(--fieldHeight, 3rem);
  padding: var(--fieldPaddingTop, 1.25rem) var(--uiFieldPaddingRight) var(--fieldPaddingBottom, .5rem) var(--uiFieldPaddingLeft);
  border-bottom: var(--uiFieldBorderWidth) solid var(--fieldBorderColor, rgba(0, 0, 0, .25));  
}

.field__input:focus{
  outline: none;
}

.field__input::-webkit-input-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input::-moz-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input:focus::-webkit-input-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__input:focus::-moz-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__label-wrap{
  box-sizing: border-box;
  pointer-events: none;
  cursor: text;
  color: #ffffff;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.field__label-wrap::after{
  content: "";
  box-sizing: border-box;
  width: 100%;
  height: 0;
  opacity: 0;

  position: absolute;
  bottom: 0;
  left: 0;
}

.field__input:focus ~ .field__label-wrap::after{
  opacity: 1;
}

.field__label{
  position: absolute;
  left: var(--uiFieldPaddingLeft);
  top: calc(50% - .5em);

  line-height: 1;
  font-size: var(--fieldHintFontSize, inherit);

  transition: top .2s cubic-bezier(0.9, -0.15, 0.1, 1.15), opacity .2s ease-out, font-size .2s ease-out;
  will-change: bottom, opacity, font-size;
}

.field__input:focus ~ .field__label-wrap .field__label,
.field__input:not(:placeholder-shown) ~ .field__label-wrap .field__label{
  --fieldHintFontSize: var(--fieldHintFontSizeFocused, .75rem);

  top: var(--fieldHintTopHover, .25rem);
}

/* 
effect 1
*/

.field_v1 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transition: opacity .2s ease-out;
  will-change: opacity;
}

/* 
effect 2
*/

.field_v2 .field__label-wrap{
  overflow: hidden;
}

.field_v2 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transform: translate3d(-105%, 0, 0);
  will-change: transform, opacity;
  transition: transform .285s ease-out .2s, opacity .2s ease-out .2s;
}

.field_v2 .field__input:focus ~ .field__label-wrap::after{
  transform: translate3d(0, 0, 0);
  transition-delay: 0;
}

/*
effect 3
*/

.field_v3 .field__label-wrap::after{
  border: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  will-change: opacity, height;
  transition: height .2s ease-out, opacity .2s ease-out;
}

.field_v3 .field__input:focus ~ .field__label-wrap::after{
  height: 100%;
}

/*
=====
LEVEL 4. SETTINGS
=====
*/

.field{
  --fieldBorderColor: #ABEBC6;
  --fieldBorderColorActive: #239B56;
}

/*
=====
DEMO
=====
*/

.page{
  box-sizing: border-box;
  background: #000000; 
  padding: 2rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 100px 80px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  margin: auto;
  /* padding: 1rem; */

  display: grid;
  grid-gap: 30px;
}
</style>
